import { ArrowBack, ArrowLeft, NavigateBefore } from "@mui/icons-material";
import {
  Box,
  Button,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import BuyCarService from "_api/Car/buyCar";
import useApi from "_api/index";
import AlertToast from "components/AlertToast";
import RenderFieldsCars from "components/Car/RenderFieldsCars";
import RenderFieldsCustomers from "components/Car/RenderFieldsCustomers";
import DropZone from "components/Dropzone_one";
import { GradientButton } from "components/GradientButton";
import { useFormik } from "formik";
import { useEffect, useState, useRef } from "react";
import * as Yup from "yup";

const ModalBuyCar = ({ open, onClose, onSaved, isEdit = false, id }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [responseCustomer, setResponseCustomer] = useState(null);
  const [responseCar, setResponseCar] = useState(null);
  const [customerImage, setCustomerImage] = useState([]);
  const [carImage, setCarImage] = useState([]);
  const [carImageInitial, setCarImageInitial] = useState([]);
  const [deleteImage, setDeleteImage] = useState([]);
  const [alertToast, setAlertToast] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const generateInitialValues = () => {
    return {
      // ข้อมูลลูกค้า
      prefix: "",
      fullName: "",
      idCardNumber: "",
      phoneNumber: "",
      address: "",
      nationality: "ไทย",

      // ข้อมูลรถ
      car_name: "",
      car_type: "", // "รถยนต์", "มอเตอร์ไซด์"
      car_no: "",
      license_plate: "",
      license_province: "",
      license_date: "",
      tax_expire_date: "",
      compulsory_expire_date: "",
      characteristic: "",
      car_brand_id: null,
      color: "",
      model: "",
      fuel_type: "",
      engine_brand: "",
      engine_number: "",
      gas_number: null,
      number_of_engine_cylinders: null,
      cc: null,
      horsepower: null,
      weight: null,
      seat: null,
      car_mileage: "",
      car_price: "",
      insurance_company: "" || null,
      insurance_level: "" || null,
      insurance_expire_date: "" || null,
      purchase_type: "cash", // "cash", "installment"
      defect: "" || null,
      car_status_id: 1,
      note: "" || null,
      car_product_type: "buy_car",
    };
  };

  const generateValidationSchema = () => {
    const customerSchema = Yup.object({
      // ข้อมูลลูกค้า
      prefix: Yup.string().required("กรุณาเลือกคำนำหน้า"),
      fullName: Yup.string().required("กรุณากรอกชื่อ-นามสกุล"),
      idCardNumber: Yup.string().when("nationality", {
        is: (val) => val === "ไทย",
        then: (schema) =>
          schema
            .required("กรุณากรอกเลขบัตรประชาชน")
            .matches(/^\d+$/, "เลขบัตรประชาชนต้องเป็นตัวเลขเท่านั้น")
            .length(13, "เลขบัตรประชาชนต้องมี 13 หลัก"),
        otherwise: (schema) =>
          schema
            .required("กรุณากรอกเลขหนังสือเดินทาง (Passport No.)")
            .matches(
              /^[A-Za-z0-9]+$/,
              "เลขหนังสือเดินทางต้องเป็นตัวอักษรหรือตัวเลขเท่านั้น"
            )
            .min(6, "เลขหนังสือเดินทางต้องมีอย่างน้อย 6 หลัก")
            .max(20, "เลขหนังสือเดินทางกรอกได้มากสุด 20 หลัก"),
      }),
      phoneNumber: Yup.string()
        .required("กรุณากรอกเบอร์โทรศัพท์")
        .min(9, "เบอร์โทรศัพท์ต้องมีอย่างน้อย 9 หลัก")
        .max(10, "เบอร์โทรศัพท์ต้องไม่เกิน 10 หลัก")
        .matches(/^\d+$/, "เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น"),
      address: Yup.string().required("กรุณากรอกที่อยู่"),
      nationality: Yup.string().required("กรุณาเลือกสัญชาติ"),
    });

    const carSchema = Yup.object({
      car_name: Yup.string().required("กรุณากรอกรถ"),
      car_type: Yup.string().required("กรุณาเลือกประเภทของรถ"),
      car_no: Yup.string().required("กรุณากรอกรหัสรถ"),
      license_plate: Yup.string().required("กรุณากรอกหมายเลขทะเบียนรถ"),
      license_province: Yup.string().required("กรุณาเลือกจังหวัดทะเบียนรถ"),
      license_date: Yup.date().required("กรุณาเลือกวันที่ออกทะเบียนรถ"),
      tax_expire_date: Yup.date().required("กรุณาเลือกวันหมดอายุภาษี"),
      compulsory_expire_date: Yup.date().required(
        "กรุณาเลือกวันหมดอายุ พ.ร.บ."
      ),
      characteristic: Yup.string().required("กรุณากรอกรายละเอียดรถ"),
      car_brand_id: Yup.number().required("กรุณาเลือกยี่ห้อรถ"),
      color: Yup.string().required("กรุณาเลือกสีรถ"),
      model: Yup.string().required("กรุณากรอกรุ่นรถ"),
      fuel_type: Yup.string().required("กรุณาเลือกประเภทเชื้อเพลิง"),
      engine_brand: Yup.string().required("กรุณากรอกยี่ห้อเครื่องยนต์"),
      engine_number: Yup.string().required("กรุณากรอกหมายเลขเครื่องยนต์"),
      number_of_engine_cylinders: Yup.number().required(
        "กรุณากรอกจำนวนกระบอกสูบ"
      ),
      cc: Yup.number().required("กรุณากรอกความจุกระบอกสูบ (CC)"),
      horsepower: Yup.number().required("กรุณากรอกแรงม้า"),
      weight: Yup.number().required("กรุณากรอกน้ำหนักรถ"),
      seat: Yup.number().required("กรุณากรอกจำนวนที่นั่ง"),
      car_mileage: Yup.number().required("กรุณากรอกระยะทางที่ใช้ไป (กิโลเมตร)"),
      car_price: Yup.number()
        .required("กรุณากรอกราคาซื้อรถ")
        .min(1, "กรุณากรอกราคาซื้อรถ"),
      purchase_type: Yup.string().required("กรุณาเลือกประเภทการชำระเงิน"),

      // ถ้ากรอก insurance_company ต้องกรอก insurance_level ด้วย
      insurance_level: Yup.string().when("insurance_company", {
        is: (val) => val && val != "",
        then: (schema) => schema.required("กรุณาเลือกชั้นประกันภัย"),
        otherwise: (schema) => schema.notRequired(),
      }),
      insurance_expire_date: Yup.date().when("insurance_company", {
        is: (val) => val && val != "",
        then: (schema) => schema.required("กรุณาเลือกวันหมดอายุประกันภัย"),
        otherwise: (schema) => schema.notRequired(),
      }),
    });

    if (isEdit) {
      return carSchema;
    } else {
      return customerSchema.concat(carSchema);
    }
  };

  const formik = useFormik({
    initialValues: generateInitialValues(),
    validationSchema: generateValidationSchema(),
    onSubmit: (values) => {
      console.log("Form submitted with values:", values);
      handleCreateBuyCar(values);
    },
  });

  const handleResetForm = () => {
    formik.resetForm({ values: generateInitialValues() });
    setIsLoading(false);
  };

  const handleCreateBuyCar = async (data) => {
    console.log("Creating Buy Car with data:", data);
    setIsLoading(true);
    // Simulate API call
    const customerData = {
      prefix: data.prefix,
      fullName: data.fullName,
      idCardNumber: data.idCardNumber,
      phoneNumber: data.phoneNumber,
      address: data.address,
      nationality: data.nationality || "ไทย",
      customer_type: "car",
    };

    const carData = {
      car_name: data.car_name,
      car_type: data.car_type,
      car_no: data.car_no,
      license_plate: data.license_plate,
      license_province: data.license_province,
      license_date: data.license_date,
      tax_expire_date: data.tax_expire_date,
      compulsory_expire_date: data.compulsory_expire_date,
      characteristic: data.characteristic,
      car_brand_id: data.car_brand_id,
      color: data.color,
      model: data.model,
      fuel_type: data.fuel_type,
      engine_brand: data.engine_brand,
      engine_number: data.engine_number,
      gas_number: data.gas_number || null,
      number_of_engine_cylinders: data.number_of_engine_cylinders,
      cc: data.cc,
      horsepower: data.horsepower,
      weight: data.weight,
      seat: data.seat,
      car_mileage: data.car_mileage,
      car_price: data.car_price,
      insurance_company: data.insurance_company || null,
      insurance_level: data.insurance_level || null,
      insurance_expire_date: data.insurance_expire_date || null,
      purchase_type: data.purchase_type || "cash",
      defect: data.defect || null,
      note: data.note || null,
      car_product_type: data.car_product_type || "buy_car",
      car_status_id: data.car_status_id || 1,
    };

    if (isEdit && id) {
      console.log("Editing existing car with ID:", id);
      try {
        console.log({ carImage, deleteImage });
        const newCarImage =
          carImage.filter((image) => image.id === undefined) || [];
        const orderData = {
          car_data: carData,
          car_photos: newCarImage || [],
        };
        console.log("Order data for update:", orderData);

        const response = await useApi.buy_car.updateBuyCar(id, orderData);
        console.log("Response from updateOrderBuyCar:", response);
        if (response?.isStatus) {
          if (deleteImage && deleteImage.length > 0) {
            handleDeleteCarImage();
          }
          onSaved();
          handleResetForm();
          onClose();
          setIsLoading(false);
        } else {
          throw new Error("Failed to update order for buy car");
        }
      } catch (error) {
        console.error("Error updating customer car:", error);
        setError(error.message || "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        setIsLoading(false);
        setAlertToast({
          open: true,
          severity: "error",
          message: "เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาตรวจสอบขอมูลอีกครั้ง",
        });
        return;
      }
    } else {
      try {
        if (customerData && carData) {
          const orderData = {
            customer_data: customerData,
            car_data: carData,
            image: customerImage || [],
            car_photos: carImage || [],
          };
          const response = await BuyCarService.createOrderBuyCar(orderData);
          console.log("Response from createOrderBuyCar:", response);
          if (response) {
            onSaved();
            handleResetForm();
            onClose();
            setIsLoading(false);
          } else {
            throw new Error("Failed to create order for buy car");
          }
        }
      } catch (error) {
        console.error("Error creating customer car:", error);
        setError(error.message || "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        setIsLoading(false);
        setAlertToast({
          open: true,
          severity: "error",
          message: "เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาตรวจสอบขอมูลอีกครั้ง",
        });
        return;
      }
    }
  };

  const handleDeleteCarImage = async () => {
    if (deleteImage && deleteImage.length > 0) {
      try {
        const response = await useApi.buy_car.deleteCarPictures(deleteImage);
        console.log("Delete car image response:", response);
        if (response.success) {
          setDeleteImage([]);
        } else {
          throw new Error("Failed to delete car images");
        }
      } catch (error) {
        console.error("Error deleting car images:", error);
        setError(error.message || "เกิดข้อผิดพลาดในการลบรูปภาพรถ");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const fetchCarData = async () => {
    if (isEdit && id) {
      setIsLoading(true);
      try {
        const response = await useApi.buy_car.getCarBuyById(id);

        if (response.success) {
          const { customer, car } = response.data;
          const customerData = {
            prefix: customer.customer_prefix || "",
            fullName: customer.customer_name || "",
            idCardNumber: customer.customer_idcard || "",
            phoneNumber: customer.customer_phonenumber || "",
            address: customer.customer_address || "",
            nationality: customer.customer_nationality || "ไทย",
          };
          formik.setValues({
            ...formik.initialValues,
            ...customerData,
            ...car,
          });
          console.log("Fetched car data for editing:", { customer, car });
          setResponseCar(car);
          if (customer.customer_image) {
            setCustomerImage([
              {
                url: customer.customer_image,
                name: "customer_image",
              },
            ]);
          } else {
            setCustomerImage([]);
          }
          if (car.car_pictures && car.car_pictures.length > 0) {
            setCarImageInitial(
              car.car_pictures.map((photo) => ({
                ...photo,
                name: "car_pictures",
              }))
            );
          }
        } else {
          throw new Error("Failed to fetch car data");
        }
      } catch (error) {
        console.error("Error fetching car data:", error);
        setError(error.message || "เกิดข้อผิดพลาดในการดึงข้อมูลรถ");
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (open) {
      // ✅ รีเซ็ตฟอร์มและค่าต่าง ๆ แค่ตอน "เปิดใหม่" (ไม่ใช่ตอน re-render ทุกครั้ง)
      handleResetForm();
      setError(null);
      setResponseCustomer(null);
      setResponseCar(null);

      // ✅ ล้างภาพเฉพาะตอนเปิด modal ใหม่เพื่อ "เพิ่มข้อมูลใหม่"
      if (!isEdit && !id) {
        setCustomerImage([]);
        setCarImage([]);
        setCarImageInitial([]);
        setDeleteImage([]);
      }
    }
    // console.log("🧠 useEffect(open) triggered - open:", open, "isEdit:", isEdit, "id:", id);
  }, [open]);

  useEffect(() => {
    if (isEdit && id) {
      fetchCarData();
    }
  }, [isEdit, id]);

  // if (isLoading && isEdit) {
  //   return (
  //     <Dialog
  //       open={open}
  //       onClose={onClose}
  //       maxWidth="md"
  //       fullWidth
  //       sx={{
  //         "& .MuiDialog-paper": {
  //           padding: 2,
  //           borderRadius: 2,
  //         },
  //       }}
  //     >
  //       <DialogTitle>
  //         <Typography variant="h4">กำลังโหลดข้อมูล...</Typography>
  //       </DialogTitle>
  //     </Dialog>
  //   );
  // }
  // start card reader
  // start websocket
  const [intendPresentFlag, setIntendPresentFlag] = useState(true);
  let wSocket = null;
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };
  const setAutoReadOptions = () => {
    const cmdNIDAutoRead = document.getElementById("chkAutoRead").checked;
    const cmdIDNumber = document.getElementById("chkAutoNIDNumber").checked;
    const cmdText = document.getElementById("chkAutoNIDText").checked;
    const cmdphoto = document.getElementById("chkAutoNIDPhoto").checked;
    const JS_OBJ = {
      Command: "SetAutoReadOptions",
      AutoRead: cmdNIDAutoRead,
      IDNumberRead: cmdIDNumber,
      IDTextRead: cmdText,
      IDATextRead: true,
      IDPhotoRead: true,
    };
    console.log("JS_OBJ >>> ", JS_OBJ);
    var jsonStr = JSON.stringify(JS_OBJ);
    wSocketSend(jsonStr);
  };
  const wSocketSend = (jsonStr) => {
    console.log("wSocketSend jsonStr > ", jsonStr);
    wSocket.send(jsonStr);
  };
  const clearScreen = () => {
    console.log("call clearScreen");
    formik.resetForm();
    // setFiles2([]);
    setCustomerImage([]);
  };

  const putToScreen = async (jsObj) => {
    // console.log("jsObj > ", jsObj);
    try {
      let prefix = "";
      let fullName = "";
      let address = "";
      const IDNum = jsObj.ID_Number;
      const IDText = jsObj.ID_Text;
      const IDPhoto = jsObj.ID_Photo;
      const status = jsObj.Status;
      if (status == 0) {
        if (IDText != "") {
          const NIDData = IDText.split("#");
          const prefix_T = NIDData[1];
          const firstName_T = NIDData[2];
          const lastName_T = NIDData[4];
          prefix = prefix_T;
          fullName = firstName_T + " " + lastName_T;
          address =
            NIDData[9] +
            " " +
            NIDData[10] +
            " " +
            NIDData[11] +
            " " +
            NIDData[12] +
            " " +
            NIDData[13] +
            "\r\n" +
            NIDData[14] +
            " " +
            NIDData[15] +
            " " +
            NIDData[16];
        }
      }
      // 2. อัปเดต Formik values พร้อมกัน
      await Promise.all([
        formik.setFieldValue("prefix", prefix),
        formik.setFieldValue("idCardNumber", IDNum),
        formik.setFieldValue("fullName", fullName),
        formik.setFieldValue("address", address),
      ]);

      // 3. อัปเดต touched หลังจาก values ถูกตั้งค่า
      formik.setTouched({
        ...formik.touched,
        idCardNumber: true,
        fullName: true,
        address: true,
      });

      // 4. ตรวจสอบ validation ใหม่
      setTimeout(() => {
        formik.validateForm();
      }, 50);

      // 5. อัปเดตรูปภาพ (ถ้ามี)
      if (IDPhoto != null) {
        const photoUrl = `data:image/jpeg;base64,${IDPhoto}`;
        const fileName = `id_card_${Date.now()}.jpg`;
        const idCardFile = dataURLtoFile(photoUrl, fileName);
        const nidCardFile = {
          file: idCardFile,
          url: photoUrl,
          name: fileName,
          status: "complete",
          isFromCard: true,
        };
        console.log("nidCardFile > ", nidCardFile);
        // setFiles2([nidCardFile]);
        setCustomerImage([nidCardFile]);
      }
    } catch (error) {
      console.error("Error in putToScreen:", error);
    }
  };

  const onGetMessage = (jsonString) => {
    const msgObj = JSON.parse(jsonString);
    console.log("💬 onGetMessage:", msgObj.Message, "Status:", msgObj.Status);

    if (msgObj.Message === "AgentStatusE") {
      if (msgObj.Status === 1) {
        setAutoReadOptions();
      } else {
        console.warn("Agent error:", msgObj.Status);
      }
    }

    if (msgObj.Message === "CardStatusChangeE") {
      console.log("CardStatusChangeE received:", msgObj.Status);

      // ล้างเฉพาะตอนถอดบัตร (-16 หรือ -15)
      if (msgObj.Status === -16 || msgObj.Status === -15) {
        console.log("🧾 Card removed - clear form and image");
        clearScreen();
      } else if (msgObj.Status === 1 || msgObj.Status === 0) {
        // ห้ามล้างภาพตอนเสียบบัตรหรือกำลังอ่าน
        console.log("Card inserted or reading, ignore clear.");
      } else {
        console.log("Unhandled card status:", msgObj.Status);
      }
    }

    if (msgObj.Message === "AutoReadIDCardE") {
      console.log("AutoReadIDCardE -> call putToScreen");
      putToScreen(msgObj);
    }
  };

  useEffect(() => {
    if (open) {
      wSocket = new WebSocket("ws://localhost:14820/TDKWAgent");
      wSocket.onopen = () => {
        console.log("WebSocket opened");
        setAutoReadOptions();
      };

      wSocket.onmessage = function (evt) {
        // console.log("RAW >>>", evt.data);
        onGetMessage(evt.data);
      };

      wSocket.onerror = (error) => {
        console.log("WebSocket: error", error);
      };

      return () => {
        wSocket.close();
        console.log("WebSocket closed");
      };
    }
  }, [open]);
  // end card reader

  // useEffect(() => {
  //   return () => {
  //     if (blobUrlRef.current) {
  //       URL.revokeObjectURL(blobUrlRef.current);
  //       blobUrlRef.current = null;
  //     }
  //   };
  // }, []);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
      // onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          padding: 2,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h4">
          {isEdit ? "แก้ไขรายละเอียดรถ" : "ซื้อรถ"}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: 2,
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: 8,
            height: 8,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: colors.grey[300],
            borderRadius: 4,
          },
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <input
            type="checkbox"
            class="form-check-input mx-3"
            id="chkAutoRead"
            onclick="setAutoReadOptions();"
            checked="checked"
            style={{ display: "none" }}
          ></input>
          <input
            type="checkbox"
            class="form-check-input"
            id="chkAutoNIDNumber"
            onclick="setAutoReadOptions();"
            checked="checked"
            style={{ display: "none" }}
          ></input>
          <input
            type="checkbox"
            class="form-check-input"
            id="chkAutoNIDText"
            checked="checked"
            onclick="setAutoReadOptions();"
            style={{ display: "none" }}
          ></input>
          <input
            type="checkbox"
            class="form-check-input"
            id="chkAutoNIDPhoto"
            checked="checked"
            onclick="setAutoReadOptions();"
            style={{ display: "none" }}
          ></input>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <RenderFieldsCustomers
              formik={formik}
              setCustomerImage={setCustomerImage}
              // images={customerImage}
              images={(customerImage || []).map((img) => ({
                url:
                  img?.url ||
                  (img?.file instanceof File
                    ? URL.createObjectURL(img.file)
                    : null),
                name: img?.name || "",
              }))}
              disabled={isEdit}
            />
            <RenderFieldsCars
              sx={{ mt: 2 }}
              formik={formik}
              setCarImage={setCarImage}
              images={carImageInitial || []} // กรณีที่มีรูปภาพเริ่มต้น
              setDeleteImage={setDeleteImage}
              isEdit={isEdit}
              data={responseCar}
            />
          </Box>
        </form>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "space-between",
          borderTop: `1px solid ${colors.grey[300]}`,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            borderRadius: 2,
            width: "auto",
            borderColor: colors.grey[400],
            color: colors.grey[400],
            "&:hover": {
              borderColor: colors.grey[400],
              color: colors.grey[400],
              borderWidth: 2,
              bgcolor: "transparent",
            },
          }}
        >
          <NavigateBefore
            sx={{
              width: 30,
              height: 30,
            }}
          />
        </Button>

        <GradientButton
          onClick={formik.handleSubmit}
          sx={{
            width: "auto",
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          type="submit"
          disabled={isLoading}
          loading={isLoading}
        >
          <Typography sx={{ fontSize: "16px" }}>บันทึก</Typography>
        </GradientButton>
      </DialogActions>
      <AlertToast
        open={alertToast.open}
        type={alertToast.severity}
        message={alertToast.message}
        onClose={() =>
          setAlertToast((prev) => ({
            ...prev,
            open: false,
          }))
        }
      />
    </Dialog>
  );
};

export default ModalBuyCar;
